import React from 'react';

export interface ChromeIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const ChromeIcon: React.FC<ChromeIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.964 9.087a4.167 4.167 0 1 0 0 8.333 4.167 4.167 0 0 0 0-8.333m0 0h9.552M4.578 7.067l4.781 8.27m2.438 8.27 4.77-8.27m6.813-2.083c0 5.752-4.663 10.416-10.416 10.416S2.547 19.006 2.547 13.254 7.21 2.837 12.964 2.837c5.752 0 10.416 4.664 10.416 10.417"/>
    </svg>
  );
};

export default ChromeIcon;
